import { QueryFieldsInput } from '@kentik/ui-shared/boards/panels';

export function getQueryFieldsSignature(data: QueryFieldsInput | undefined): string {
  const filters = data?.filters;
  return JSON.stringify({
    measurement: data?.measurement ?? null,
    metrics: data?.metrics ?? [],
    dimensions: data?.dimensions ?? [],
    filters: filters ?? null,
    filterGroups: filters?.dimensions?.filterGroups ?? null,
    reAgg: data?.reAgg ?? null,
    rollups: data?.rollups ?? []
  });
}
